import { Navigate } from "react-router-dom";
import { AdminLayout } from "../pages/dashboard/layout/AdminLayout";
import { LazyRoute } from "../utils/helpers";
import { IModuleRouter } from "./index";

export const AdminDashRouter: IModuleRouter = {
  key: "dashboard",
  guard: (loggedIn) => loggedIn,
  layout: AdminLayout,
  routes: [
    {
      index: true,
      element: <Navigate to="/dashboard" />,
    },
    LazyRoute(
      {
        path: "/dashboard",
      },
      () => import("../pages/dashboard/DashboardPage/DashboardPage")
    ),
    LazyRoute(
      {
        path: "/dashboard/:id",
      },
      () => import("../pages/dashboard/DashboardPage/CompanyInfoPage")
    ),
    LazyRoute(
      {
        path: "/consultants",
      },
      () => import("../pages/dashboard/Consultant")
    ),
    LazyRoute(
      {
        path: "/consultants/:id",
      },
      () => import("../pages/dashboard/Consultant/ConsultantDetails")
    ),
    LazyRoute(
      {
        path: "/settlement",
      },
      () => import("../pages/dashboard/Settlement")
    ),
    LazyRoute(
      {
        path: "/consultants/:id/collection-history",
      },
      () => import("../pages/dashboard/Consultant/CollectionHistory")
    ),

    LazyRoute(
      {
        path: "/agents",
      },
      () => import("../pages/dashboard/Agents")
    ),
    LazyRoute(
      {
        path: "/agents/:id",
      },
      () => import("../pages/dashboard/Agents/AgentsDetails")
    ),
    LazyRoute(
      {
        path: "/agents/:id/edit",
      },
      () => import("../pages/dashboard/Agents/Edit")
    ),
    LazyRoute(
      {
        path: "/agents/:id/collection-history",
      },
      () => import("../pages/dashboard/Agents/CollectionHistory")
    ),
    LazyRoute(
      {
        path: "/agents/create-new-agent",
      },
      () => import("../pages/dashboard/Agents/NewAgent")
    ),

    LazyRoute(
      {
        path: "/tax-collection",
      },
      () => import("../pages/dashboard/TaxCollection")
    ),

    LazyRoute(
      {
        path: "/transaction-funding",
      },
      () => import("../pages/dashboard/TransactionFunding")
    ),

    LazyRoute(
      {
        path: "/change-password",
      },
      () => import("../pages/dashboard/ChangePassword")
    ),

    LazyRoute(
      {
        path: "/agent-transactions",
      },
      () => import("../pages/dashboard/AgentTransaction")
    ),


    // 

    {
      path: "*",
      element: <div>Not found</div>,
    },
  ],
};
